import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface Props {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: Props) {
  return (
    <div className={cn('text-center py-16 px-6', className)}>
      {icon && <div className="mx-auto mb-4 inline-flex p-3 rounded-2xl bg-slate-100 text-slate-500">{icon}</div>}
      <h3 className="text-base font-semibold text-ink">{title}</h3>
      {description && <p className="mt-1 text-sm text-slate-500 max-w-md mx-auto">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
